import type { SubPractices } from "../config.types";

import {
  immigrationBookLssScreens,
  immigrationEligibleForLssScreens,
  intakeConfirmationScreens,
} from "./common-immigration";

export const immigrationGreenCard: SubPractices = {
  firstScreen: "service-type",
  screens: {
    "service-type": {
      next: async ({ answers }) => {
        const { serviceType } = answers;

        if (serviceType === "New green card application") {
          return "sponsor-type";
        }
        return "deportation-or-removal";
      },
    },
    "green-card-status": {
      next: async ({ answers }) => {
        const { greenCardStatus } = answers;
        if (greenCardStatus === "I have a green card and live in the U.S.") {
          return "green-card-type";
        }
        return "out-of-scope";
      },
    },
    "green-card-type": {
      next: async () => "case-urgency",
    },
    "sponsor-type": {
      next: async ({ answers }) => {
        const { sponsorType } = answers;
        if (sponsorType === "employer") return "job-offer";
        if (sponsorType === "I don’t have a sponsor") return "advanced-degree";
        return "sponsor-status";
      },
    },
    "sponsor-status": {
      next: async ({ answers }) => {
        const { sponsorType, sponsorStatus } = answers;
        if (sponsorStatus === "U.S Citizen") {
          if (sponsorType === "child") return "child-age";
          return "deportation-or-removal";
        }
        if (sponsorStatus === "Green card holder") {
          if (sponsorType === "spouse") return "deportation-or-removal";

          if (sponsorType === "parent") return "child-age";
          return "out-of-scope";
        }
        return "out-of-scope";
      },
    },
    "child-age": {
      next: async ({ answers }) => {
        const { sponsorType, isChildUnderTwentyOne } = answers;
        if (sponsorType === "parent") {
          if (isChildUnderTwentyOne === "Yes") return "deportation-or-removal";
          return "child-marital-status";
        }
        if (sponsorType === "child" && isChildUnderTwentyOne === "No") {
          return "deportation-or-removal";
        }
        return "out-of-scope";
      },
    },
    "child-marital-status": {
      next: async ({ answers }) => {
        const { isChildMarried } = answers;
        if (isChildMarried === "No") {
          return "deportation-or-removal";
        }
        return "out-of-scope";
      },
    },
    "job-offer": {
      next: async ({ answers }) => {
        const { jobOffer } = answers;
        if (jobOffer === "No") return "out-of-scope";
        return "deportation-or-removal";
      },
    },
    "advanced-degree": {
      next: async ({ answers }) => {
        const { advancedDegree } = answers;
        if (advancedDegree === "No") return "exceptional-ability";
        return "deportation-or-removal";
      },
    },
    "exceptional-ability": {
      next: async ({ answers }) => {
        const { exceptionalAbility } = answers;
        if (exceptionalAbility === "No") return "humanitarian-status";
        return "deportation-or-removal";
      },
    },
    "humanitarian-status": {
      next: async ({ answers }) => {
        const { humanitarianStatus } = answers;
        if (humanitarianStatus === "No") return "out-of-scope";
        return "deportation-or-removal";
      },
    },
    "applicant-type": {
      next: async () => "case-urgency",
    },
    "case-urgency": {
      next: async () => "more-info",
    },
    "sponsor-info": {
      next: async () => "currently-represented",
    },

    ...immigrationEligibleForLssScreens,

    "funding-source": {
      next: async () => "beneficiary-region",
    },
    "beneficiary-region": {
      next: async () => "more-info",
    },

    ...intakeConfirmationScreens,
    ...immigrationBookLssScreens,

    "out-of-scope": {
      next: async () => undefined,
    },
  },
};
